import {Link, SvgIcon, Typography, useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';

export default function Footer() {
  const theme = useTheme();

  const linkStyle = {
    color: theme.vars.palette.text.primary,
    '&:hover': {
      color: theme.vars.palette.primary.main,
    },
  };

  const iconStyle = {
    fill: theme.vars.palette.text.primary,
    '&:hover': {
      fill: theme.vars.palette.primary.main,
    },
  };

  const socialStyle = {
    width: 16,
    height: 16,
    ...iconStyle,
  };

  return (
    <footer style={{paddingTop: 32, paddingBottom: 32, fontSize: 14}}>
      <Typography fontSize={14}>
        © {new Date().getFullYear()} Planet Labs PBC All rights reserved.
      </Typography>

      <Box
        flexDirection="row"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
      >
        <Box
          flexDirection="row"
          display="flex"
          flexWrap="wrap"
          gap={0.5}
          alignItems="center"
        >
          <Link
            href="https://www.planet.com/privacy"
            target="_blank"
            sx={linkStyle}
          >
            Privacy Policy
          </Link>
          |
          <Link
            href="https://www.planet.com/privacy/#california"
            target="_blank"
            sx={linkStyle}
          >
            California Privacy Notice
          </Link>
          |
          <Link
            sx={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              ...linkStyle,
            }}
            onClick={e => {
              e.stopPropagation();
              window.OneTrust.ToggleInfoDisplay();
            }}
          >
            Your&nbsp;Privacy&nbsp;Choices
            <SvgIcon viewBox="0 0 30 14" sx={{width: 32, ...iconStyle}}>
              <path
                fill={theme.vars.palette.background.default}
                d="M7.4,12.8h6.8l3.1-11.6H7.4C4.2,1.2,1.6,3.8,1.6,7S4.2,12.8,7.4,12.8z"
              ></path>
              <path d="M22.6,0H7.4c-3.9,0-7,3.1-7,7s3.1,7,7,7h15.2c3.9,0,7-3.1,7-7S26.4,0,22.6,0z M1.6,7c0-3.2,2.6-5.8,5.8-5.8 h9.9l-3.1,11.6H7.4C4.2,12.8,1.6,10.2,1.6,7z"></path>
              <path
                fill={theme.vars.palette.background.default}
                d="M24.6,4c0.2,0.2,0.2,0.6,0,0.8l0,0L22.5,7l2.2,2.2c0.2,0.2,0.2,0.6,0,0.8c-0.2,0.2-0.6,0.2-0.8,0 l0,0l-2.2-2.2L19.5,10c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8l0,0L20.8,7l-2.2-2.2c-0.2-0.2-0.2-0.6,0-0.8 c0.2-0.2,0.6-0.2,0.8,0l0,0l2.2,2.2L23.8,4C24,3.8,24.4,3.8,24.6,4z"
              ></path>
              <path d="M12.7,4.1c0.2,0.2,0.3,0.6,0.1,0.8l0,0L8.6,9.8C8.5,9.9,8.4,10,8.3,10c-0.2,0.1-0.5,0.1-0.7-0.1l0,0 L5.4,7.7c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0l0,0L8,8.6l3.8-4.5C12,3.9,12.4,3.9,12.7,4.1z"></path>
            </SvgIcon>
          </Link>
          |
          <Link
            href="https://www.planet.com/terms-of-use"
            target="_blank"
            sx={linkStyle}
          >
            Terms of Use
          </Link>
          |
          <Link
            href="https://www.planet.com/cookie-notice"
            target="_blank"
            sx={linkStyle}
          >
            Cookie Notice
          </Link>
        </Box>
        <Box display="flex" alignItems="center" gap={2} ml="auto">
          <Link href="https://twitter.com/planet" aria-label="Twitter">
            <SvgIcon viewBox="0 0 19.57 20" sx={socialStyle}>
              <path d="M11.647 8.469 18.932 0h-1.726L10.88 7.353 5.827 0H0l7.64 11.119L0 20h1.726l6.68-7.765L13.743 20h5.827zm-2.365 2.748-.774-1.107L2.349 1.3H5l4.971 7.11.774 1.107 6.461 9.242h-2.651z"></path>
            </SvgIcon>
          </Link>
          <Link
            href="https://www.linkedin.com/company/planet-labs/"
            aria-label="Linked In"
          >
            <SvgIcon viewBox="0 0 10.5 10.5" sx={socialStyle}>
              <path d="M9.8 0h-9C.3 0 0 .3 0 .8v9c0 .4.3.8.7.8h9c.4 0 .8-.3.8-.8v-9c0-.5-.3-.8-.7-.8M3.2 9H1.6V4h1.6zm-.8-5.7c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9M9 9H7.5V6.6c0-.6 0-1.3-.8-1.3s-.9.6-.9 1.3V9H4.2V4h1.5v.7c.2-.4.7-.8 1.5-.8 1.6 0 1.9 1 1.9 2.4V9z"></path>
            </SvgIcon>
          </Link>
          <Link
            href="https://www.facebook.com/PlanetLabs/"
            aria-label="Facebook"
          >
            <SvgIcon viewBox="0 0 10.26 19.75" sx={socialStyle}>
              <path d="M6.66 19.75v-9h3l.45-3.51H6.66V5c0-1 .28-1.71 1.74-1.71h1.86V.14A25 25 0 0 0 7.55 0C4.87 0 3 1.64 3 4.64v2.59H0v3.51h3v9h3.66z"></path>
            </SvgIcon>
          </Link>
          <Link
            href="https://www.instagram.com/planetlabs/"
            aria-label="Instagram"
          >
            <SvgIcon viewBox="0 0 16.7 16.7" sx={socialStyle}>
              <path
                fillRule="evenodd"
                d="M2.14 0h12.41a2.15 2.15 0 0 1 2.15 2.14v12.41a2.15 2.15 0 0 1-2.14 2.14H2.14A2.15 2.15 0 0 1 0 14.55V2.14A2.15 2.15 0 0 1 2.14 0m10 1.86a.75.75 0 0 0-.75.75v1.8a.75.75 0 0 0 .75.75H14a.75.75 0 0 0 .75-.75v-1.8a.75.75 0 0 0-.75-.75h-1.84zm2.65 5.21h-1.45a4.9 4.9 0 0 1 .21 1.43 5.11 5.11 0 0 1-5.19 5 5.11 5.11 0 0 1-5.19-5 4.9 4.9 0 0 1 .21-1.43H1.86v7.05a.67.67 0 0 0 .66.66h11.63a.67.67 0 0 0 .66-.66V7.06zm-6.45-2A3.3 3.3 0 0 0 5 8.31a3.3 3.3 0 0 0 3.35 3.25 3.3 3.3 0 0 0 3.35-3.25 3.3 3.3 0 0 0-3.34-3.25z"
              ></path>
            </SvgIcon>
          </Link>
          <Link href="https://medium.com/planet-stories" aria-label="Medium">
            <SvgIcon viewBox="0 0 50 50" sx={socialStyle}>
              <path d="M49.8 9.2 34.6.2c-.2 0-.2 0-.4-.2H34c-.5 0-1.1.4-1.5.9l-8.8 16.5 11 20.8zq.3.3 0 0M19 13.9v18.9l14.4 8.3zm16.4 28.5 11.7 6.9c1.5.9 2.7.2 2.7-1.5v-33zm-18.8-33L1.8.9C1.6.6 1.3.6 1.1.6.4.6 0 1.3 0 2.1v37.3c0 1.1.5 2.1 1.5 2.6l13 7.7c.4.2.7.2.9.2.7 0 1.5-.6 1.5-1.9z"></path>
            </SvgIcon>
          </Link>
          <Link
            href="https://www.youtube.com/channel/UCiyS6coRsDQ17b3Kj9bl8jw"
            aria-label="Youtube"
          >
            <SvgIcon viewBox="0 0 1792 1280" sx={socialStyle}>
              <path d="M1280 640q0-37.05-30-54L738 266c-20.7-13.3-42.3-14-65-2-22 12-33 30.7-33 56v640c0 25.3 11 44 33 56 10.7 5.3 21 8 31 8 13.3 0 24.7-3.3 34-10l512-320q30-16.95 30-54m512 0c0 64-.3 114-1 150s-3.5 81.5-8.5 136.5-12.5 104.2-22.5 147.5q-16.05 73.05-69 123c-52.95 49.95-76.7 52.7-124 58-148 16.7-371.7 25-671 25s-523-8.3-671-25c-47.3-5.3-88.8-24.7-124.5-58s-58.8-74.3-69.5-123c-9.3-43.3-16.5-92.5-21.5-147.5S1.7 826 1 790s-1-86-1-150 .3-114 1-150 3.5-81.5 8.5-136.5S22 249.3 32 206q16.05-73.05 69-123c52.95-49.95 76.7-52.7 124-58C373 8.3 596.7 0 896 0s523 8.3 671 25c47.3 5.3 88.8 24.7 124.5 58s58.8 74.3 69.5 123c9.3 43.3 16.5 92.5 21.5 147.5s7.8 100.5 8.5 136.5 1 86 1 150"></path>
            </SvgIcon>
          </Link>
        </Box>
      </Box>
    </footer>
  );
}
